import type { SearchMode, VideoListMeta } from '@/api/types';
import { storageKeys } from '@/config/app';
import { session } from '@/lib/storage';

/**
 * Двухфазный поиск (ADR-009, D6): пока человек печатает, уходит дешёвый запрос `search_mode=typing`
 * (на бэкенде — ноль внешних вызовов), а после Enter или паузы — полный `submitted`.
 *
 * Фазы включаются только когда бэкенд уже отвечает движком v3 — признак: в ответе есть `meta.zones`.
 * Со старым конвейером режим ничего не меняет, а второй запрос удвоил бы вызовы LLM и счётчик поисков,
 * поэтому до первого ответа v3 приложение ищет как раньше: один запрос после задержки ввода.
 */
export function isTwoPhaseSearch(): boolean {
  return session.get(storageKeys.searchTwoPhase) === '1';
}

export function noteSearchEngine(meta: VideoListMeta): void {
  if (meta.zones) session.set(storageKeys.searchTwoPhase, '1');
}

/**
 * Значение параметра `search_mode` для запроса. Уходят «набор на лету» и «пауза»: «отправлен» — поведение
 * бэкенда по умолчанию, и параметр для него не шлётся. Иначе первый же ответ поиска v3 включал двухфазный
 * режим, параметры запроса менялись, он уходил повторно — и каждый первый поиск сессии считался дважды.
 */
export function searchModeParam(mode: SearchMode, query: string): SearchMode | undefined {
  return query && mode !== 'submitted' && isTwoPhaseSearch() ? mode : undefined;
}

/** Сколько из уже загруженных видео лежит в зоне «точные»: зоны идут подряд, точные — первыми. */
export function exactCount(meta: VideoListMeta | undefined, loaded: number): number | null {
  if (!meta?.zones) return null;
  return Math.min(meta.zones.exact, loaded);
}
